import React, { useState } from 'react'
import Tabs, { TabTrigger, TabTriggerGroup } from '@zera-admin/tabs'
import { Column, Row } from '@zera-admin/page'
import Select, { SelectOptionProps } from '@zera-admin/select'
import { string } from '@zera-admin/helpers'

import { getFieldOptions } from 'bi-tool/visualizations/visualization/getters'

import * as Styled from './HotelDefinitions.styled'
import { HOTEL_FIELDS } from './constants'
import { HotelDefinitionsProps } from './types'

const HotelDefinitions: React.FunctionComponent<HotelDefinitionsProps> = ({
  fields,
  onChange,
  options,
}) => {
  const [fieldOptions, setFieldOptions] = useState<SelectOptionProps[]>(
    getFieldOptions(fields)
  )

  const handleChangeFieldInput = (value: string) => {
    const option = {
      label: value,
      value,
    }
    const index = fieldOptions.findIndex(
      (reference) => reference.value === parseInt(option.value)
    )
    let optionsInstance = [...fieldOptions]

    if (value && index === -1) {
      optionsInstance[0] = option
    } else {
      optionsInstance = getFieldOptions(fields)
    }

    setFieldOptions(optionsInstance)
  }

  const renderTabs = () => {
    return (
      <Tabs id="tabs">
        <TabTriggerGroup>
          <TabTrigger>Veri </TabTrigger>
        </TabTriggerGroup>
        <div style={{ marginTop: '2vh' }}>{renderDataTab()}</div>
      </Tabs>
    )
  }

  const renderDataTab = () => {
    const values = options?.fields || {}

    return HOTEL_FIELDS.map((hotelField, index) => (
      <Row style={{ width: '100%' }} key={index} xs={{ direction: 'column' }}>
        <Column>
          <Select
            name={hotelField.value}
            options={fieldOptions}
            onChange={(props) => {
              onChange({
                ...options,
                fields: {
                  ...options.fields,
                  [hotelField.value]: (props as SelectOptionProps)
                    .value as string,
                },
              })
            }}
            onInputChange={handleChangeFieldInput}
            value={
              values[hotelField.value]
                ? {
                    label: string.textify(values[hotelField.value]),
                    value: values[hotelField.value],
                  }
                : { label: '', value: '' }
            }
            label={hotelField.label}
            placeholder="Seçim yapınız"
          />
        </Column>
      </Row>
    ))
  }

  return (
    <Styled.HotelDefinitionField>{renderTabs()}</Styled.HotelDefinitionField>
  )
}

export default HotelDefinitions
